'use client';

import type { DetailedHTMLProps, HTMLAttributes } from 'react';

export type BreadcrumbsScrollerProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
export function BreadcrumbsScroller({ children, ...props }: BreadcrumbsScrollerProps) {
    return (
        <div
            {...props}
            ref={(element) => {
                if (!element) {
                    return;
                }

                element.scrollLeft = element.scrollWidth;
            }}
        >
            {children}
        </div>
    );
}
